// Extended regeneration reasons enum for server-side use
export var RegenerationReason;
(function (RegenerationReason) {
    RegenerationReason["SCHEMA_UPGRADE"] = "schema_upgrade";
    RegenerationReason["CUSTOM_FIELDS_ADDED"] = "custom_fields_added";
    RegenerationReason["PROMPT_IMPROVED"] = "prompt_improved";
    RegenerationReason["MODEL_UPGRADED"] = "model_upgraded";
    RegenerationReason["DEPENDENCY_UPDATED"] = "dependency_updated";
    RegenerationReason["MANUAL_REQUEST"] = "manual_request";
    RegenerationReason["ERROR_RECOVERY"] = "error_recovery";
})(RegenerationReason || (RegenerationReason = {}));
